// src/firebase/firebaseInit.js
// eslint-disable-next-line import/named
import { initializeApp } from 'firebase/app';
// eslint-disable-next-line import/named
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
// eslint-disable-next-line import/named
import { getFirestore } from 'firebase/firestore';
// eslint-disable-next-line import/named
import { getStorage } from 'firebase/storage';
// Import Functions to register the service
// eslint-disable-next-line import/named
import { getFunctions } from 'firebase/functions';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { collection, doc, addDoc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, orderBy, where, writeBatch, serverTimestamp } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Validate config presence to prevent silent failures
// Redacted logging for security, but checks if key fields are missing
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error('Firebase Configuration Error: Missing environment variables.');
  console.error('Ensure REACT_APP_FIREBASE_API_KEY and others are set in your .env.local file.');
}

const app = initializeApp(firebaseConfig);
export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export { ref, uploadBytes, getDownloadURL, deleteObject };
export { collection, doc, addDoc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, orderBy, where, writeBatch, serverTimestamp };

// Test Firebase connectivity
export const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connectivity...');

    // Test basic initialization
    console.log('App initialization status:', !!app);
    console.log('Auth initialization status:', !!auth);

    // Test auth endpoint connectivity
    const response = await fetch('https://www.googleapis.com/identitytoolkit/v3/relyingparty/getProjectConfig?key=' + firebaseConfig.apiKey);
    console.log('Firebase endpoint test response:', response.status);

    return {
      success: true,
      app: !!app,
      auth: !!auth,
      endpointAccess: response.status === 200
    };
  } catch (error) {
    console.error('Firebase connectivity test failed:', error);
    return {
      success: false,
      error: error.message,
      app: !!app,
      auth: !!auth,
      endpointAccess: false
    };
  }
};